import React from "react";
import PageData from "../../PageData/PageData";
import { getAxios } from "../../../../helper/AxiosHelper";
import { ActionButton } from "../../GeneralUI";

import { useQuery } from "react-query";
const Country = () => {
  const countryColumns = [
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
    },

    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => <ActionButton row={row} pageTitle="country" />,
    },
  ];
  async function getField() {
    const url = `/admin/country`;
    try {
      const response = await getAxios(url);
      const fetchedList = response.data;

      return fetchedList.country;
    } catch (error) {
      console.log(error);
    }
  }
  const { data, error, isLoading } = useQuery("CountryList", getField);
  if (isLoading) {
    return <div>Loading......</div>;
  }
  if (error) {
    return <div>Error:{error.message}</div>;
  }

  return (
    <>
      <PageData columns={countryColumns} tableData={data} title="Country" />
    </>
  );
};

export default Country;
